/* Copyright 2009-2014, Texas Instruments Inc. All rights reserved. */
( function( $ ) {
	$.create = function( tagName, doc ) {
		doc = doc || document;
		if( doc.createElementNS ) return $( doc.createElementNS( 'http://www.w3.org/1999/xhtml', tagName ) );
		else return $( doc.createElement( tagName ) );
	};
}( window.jQuery ) );